<template>
    <fragment>
        <v-alert border="left" text type="warning" elevation="0" class="mt-3">
            {{ $t('subscriptionDialog.virtualTags.sourceDescription') }}
        </v-alert>
        <virtual-tag-table :loading="$wait.is(['getSubscriptionAccountVirtualTags', 'addSubscriptionTag'])" :items="virtualTags">
            <template #default="{ isValid, formId, form, loading, reset }">
                <v-btn
                    color="primary"
                    :disabled="!isValid || loading"
                    :loading="loading"
                    :form="formId"
                    text
                    @click="addSubscriptionTag(form).then(reset)"
                >
                    <v-icon left>add</v-icon>
                    Add
                </v-btn>
            </template>
            <template #item="{ item }">
                <v-btn text color="error" :loading="$wait.is('deleteSubscriptionTag')" @click="deleteSubscriptionTag(item)">
                    <v-icon left>delete</v-icon>
                    Drop
                </v-btn>
            </template>
        </virtual-tag-table>
    </fragment>
</template>

<i18n>
{
    "en": {
        "subscriptionDialog.virtualTags.sourceDescription": "Virtual tags are a stop gap solution that should be used sparingly. Best practices dictate tagging your consumption in the cloud vendor of choice instead. However, in the cases where historical spend has not been tagged properly you can use virtual tags to cover untracked spend.",
        "subscriptionDialog.virtualTags.errorCreating": "There was an error creating this virtual tag. Please check that there are no conflicting tag keys already on this service.",
        "subscriptionDialog.virtualTags.successCreating": "Your virtual tag has been successfully created. These rules will be applied during the next import at the end of the day.",
        "subscriptionDialog.virtualTags.errorDeleting": "There was an error deleting this virtual tag. Please refresh this page and try again.",
        "subscriptionDialog.virtualTags.successDeleting": "Your virtual tag has been successfully deleted for this period. This update in rules will be applied during the next import at the end of the day."
    }
}
</i18n>

<script>
import ApiV2 from '@/lib/ApiV2.ts';
import { waitFor } from '@/plugins/vue-wait';
import VirtualTagTable from '@/components/Domain.VirtualTags/VirtualTagTable.vue';
import { toastError, toastSuccess } from '@/components/Common/Toast.vue';
export default {
    props: ['value', 'loading'],
    components: { VirtualTagTable },
    data() {
        return {
            virtualTags: [],
        };
    },
    watch: {
        value: {
            handler(svc) {
                if (!svc) return;
                this.getSubscriptionAccountVirtualTags();
            },
            immediate: true,
        },
    },
    methods: {
        getSubscriptionAccountVirtualTags: waitFor('getSubscriptionAccountVirtualTags', async function () {
            this.virtualTags = await ApiV2.http
                .get(
                    `/api/metadata/subscriptions/${this.value.subscriptionId}/virtualtags`
                )
                .then((r) => r.data);
        }),
        addSubscriptionTag: waitFor('addSubscriptionTag', async function (newTag) {
            try {
                await ApiV2.http.post(
                    `/api/metadata/subscriptions/${this.value.subscriptionId}/virtualtags`,
                    newTag
                );
                this.getSubscriptionAccountVirtualTags();
                toastSuccess(this.$t('subscriptionDialog.virtualTags.successCreating'));
            } catch (err) {
                toastError(this.$t('subscriptionDialog.virtualTags.errorCreating'));
            }
        }),
        deleteSubscriptionTag: waitFor('deleteSubscriptionTag', async function (tagToDelete) {
            try {
                await ApiV2.http.delete(
                    `/api/metadata/subscriptions/${this.value.subscriptionId}/virtualtags/${tagToDelete.tagKey}/${tagToDelete.year}/${tagToDelete.month}`
                );
                this.getSubscriptionAccountVirtualTags();
                toastSuccess(this.$t('subscriptionDialog.virtualTags.successDeleting'));
            } catch (err) {
                toastError(this.$t('subscriptionDialog.virtualTags.errorDeleting'));
            }
        }),
    },
};
</script>